const name = {
  key: 'name',
  label: '配達エリア名',
} as const;
const postalCode = {
  key: 'postalCode',
  label: '郵便番号',
} as const;
const deliveryFee = {
  key: 'deliveryFee',
  label: '配達料',
} as const;
const asapDuration = {
  key: 'asapDuration',
  label: '最短配達時間',
} as const;

export const deliveryAreaForm = {
  name,
  postalCode,
  deliveryFee,
  asapDuration,
} as const;

export type DeliveryAreaField = {
  name: string;
  postalCode: string;
  deliveryFee: number;
  asapDuration: number;
};
